var map = {
	"./Spinner-1s-38px.gif": 84493,
	"./TickSquare.svg": 96416,
	"./action-icn.svg": 94077,
	"./applications-icn.svg": 96458,
	"./arrow-right-circle copy.svg": 26808,
	"./arrow-right-circle.svg": 12137,
	"./arrow-right-white-circle copy.svg": 25928,
	"./arrow-right-white-circle.svg": 41401,
	"./arrow-righti-circle-white.svg": 43174,
	"./attach-icn.svg": 69016,
	"./back-icn.svg": 49794,
	"./blue-arrow-right.svg": 71243,
	"./btn-img.svg": 92744,
	"./btn-spinner.gif": 39293,
	"./calendar-icn.svg": 36817,
	"./cambridge.png": 65320,
	"./checkbox-active.svg": 27600,
	"./close-icn.svg": 76575,
	"./continue-icn.svg": 5128,
	"./courses-icn.svg": 9425,
	"./delete-confirmation-icn.svg": 32590,
	"./delete-icn.svg": 65950,
	"./doc-icn.svg": 3785,
	"./down-arrow-white.svg": 16846,
	"./down-arrow.svg": 99778,
	"./drag-icn.svg": 97497,
	"./dummy-map.png": 36527,
	"./edit-btn.svg": 43681,
	"./edu-tech-background.png": 80648,
	"./edutech-loader.gif": 38531,
	"./expand-collapse.svg": 52166,
	"./filter-active.svg": 56535,
	"./filter-clear.svg": 73980,
	"./filter-icn.svg": 32153,
	"./harvard.png": 75942,
	"./header-logo.png": 9243,
	"./home-icn.svg": 88574,
	"./iconly-dark-delete.svg": 72171,
	"./iconly-light-location.png": 49697,
	"./larrow.png": 41187,
	"./logo.png": 65549,
	"./logo.svg": 67503,
	"./logout-icn.svg": 85513,
	"./menu-active-arrow.svg": 75162,
	"./metropoliton.png": 49568,
	"./mit-engineering.png": 40002,
	"./modal-close-icn.svg": 76287,
	"./more-icn.svg": 75368,
	"./msg-icn.svg": 42884,
	"./network-issue.png": 106,
	"./no-data-found.png": 855,
	"./no-data.png": 78780,
	"./no_img.png": 74249,
	"./oxford-university-icon.svg": 30169,
	"./oxford.png": 14510,
	"./password_hide.svg": 52608,
	"./password_show.svg": 97811,
	"./pickauni-logo-white.png": 45504,
	"./plus-icn-blue.svg": 380,
	"./plus-icn.svg": 8775,
	"./plus-white-icn.svg": 28611,
	"./rarrow.png": 1369,
	"./red_tick.svg": 72525,
	"./search-icn.svg": 99227,
	"./setup-icn.svg": 27212,
	"./slick-left-arrow.svg": 15436,
	"./slick-right-arrow.svg": 97875,
	"./start-icn.svg": 58603,
	"./status-completed-icn.svg": 39449,
	"./status-dwn-arrow.svg": 4284,
	"./students-icn.svg": 1399,
	"./subjects-icn.svg": 60892,
	"./submit-btn-arrow.svg": 5441,
	"./tick-gray-icn.svg": 78198,
	"./timeline-white.svg": 2963,
	"./univ-slider-img1.png": 54037,
	"./univ-slider-img2.jpg": 53338,
	"./university-icn.svg": 8475,
	"./university-img.png": 57378,
	"./up-arrow-white.svg": 36173,
	"./user-icon.svg": 70195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;